const API_VERSION = process.env.REACT_APP_SHOPIFY_API_VERSION || "2024-10";

export const shopifyEnv = {
    storeDomain: process.env.REACT_APP_SHOPIFY_STORE_DOMAIN,
    storefrontToken: process.env.REACT_APP_SHOPIFY_STOREFRONT_TOKEN,
    apiVersion: API_VERSION,
};

/** True once both required env vars are set, i.e. the real store can be used. */
export function isShopifyConfigured(): boolean {
    return Boolean(shopifyEnv.storeDomain && shopifyEnv.storefrontToken);
}

export function shopifyGraphqlEndpoint(): string {
    return `https://${shopifyEnv.storeDomain}/api/${shopifyEnv.apiVersion}/graphql.json`;
}
